import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  // Home
  {
    path: '',
    loadChildren: () =>
      import('./components/pages/home/home.module').then((m) => m.HomeModule),
    data: { breadcrumb: '首页' },
  },
  {
    path: 'home-v2',
    loadChildren: () =>
      import('./components/pages/home-two/home-two.module').then(
        (m) => m.HomeTwoModule
      ),
    data: { breadcrumb: 'Homepage' },
  },
  {
    path: 'home-v3',
    loadChildren: () =>
      import('./components/pages/home-three/home-three.module').then(
        (m) => m.HomeThreeModule
      ),
    data: { breadcrumb: 'Homepage' },
  },
  // About Us
  {
    path: 'aboutUs',
    loadChildren: () =>
      import('./components/pages/about/about.module').then(
        (m) => m.AboutModule
      ),
    data: { breadcrumb: '关于誉州' },
  },
  // Services
  {
    path: 'services',
    loadChildren: () =>
      import('./components/pages/services/services.module').then(
        (m) => m.ServicesModule
      ),
    data: { breadcrumb: '品质服务' },
  },
  // Team
  {
    path: 'team',
    loadChildren: () =>
      import('./components/pages/team/team.module').then((m) => m.TeamModule),
    data: { breadcrumb: '联系我们' },
  },
  // Company
  // {
  //   path: 'company',
  //   loadChildren: () =>
  //     import('./components/pages/company/company.module').then(
  //       (m) => m.CompanyModule
  //     ),
  //   data: { breadcrumb: '企业文化' },
  // },
  {
    path: 'company-details/:id',
    loadChildren: () =>
      import('./components/pages/wenhua-details/wenhua-details.module').then(
        (m) => m.WenhuaDetailsModule
      ),
    data: { breadcrumb: '文化详情' },
  },
  // Portfolio
  {
    path: 'portfolio-grid',
    loadChildren: () =>
      import('./components/pages/portfolio-grid/portfolio-grid.module').then(
        (m) => m.PortfolioGridModule
      ),
    data: { breadcrumb: 'Portfolio Grid' },
  },
  {
    path: 'portfolio-masonry',
    loadChildren: () =>
      import(
        './components/pages/portfolio-masonry/portfolio-masonry.module'
      ).then((m) => m.PortfolioMasonryModule),
    data: { breadcrumb: 'Portfolio Masonry' },
  },

  {
    path: 'error-404',
    loadChildren: () =>
      import('./components/pages/error-page/error-page.module').then(
        (m) => m.ErrorPageModule
      ),
    data: { breadcrumb: 'Error 404' },
  },
  // Blog

  {
    path: 'blog',
    loadChildren: () =>
      import('./components/pages/blog/blog.module').then((m) => m.BlogModule),
    data: { breadcrumb: '新闻资讯' },
  },
  {
    path: 'blog-details',
    loadChildren: () =>
      import('./components/pages/blog-details/blog-details.module').then(
        (m) => m.BlogDetailsModule
      ),
    data: { breadcrumb: '新闻详情' },
  },
  // Contact
  {
    path: 'contact',
    loadChildren: () =>
      import('./components/pages/contact/contact.module').then(
        (m) => m.ContactModule
      ),
    data: { breadcrumb: '产品中心' },
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('./components/pages/contact/contact.module').then(
        (m) => m.ContactModule
      ),
    data: { breadcrumb: '产品中心' },
  },
  {
    path: 'product-details',
    loadChildren: () =>
      import('./components/pages/product-details/product-details.module').then(
        (m) => m.ProductDetailsModule
      ),
    data: { breadcrumb: '产品详情' },
  },

  {
    path: '**',
    loadChildren: () =>
      import('./components/pages/error-page/error-page.module').then(
        (m) => m.ErrorPageModule
      ),
    data: { breadcrumb: 'Error 404' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
